<!-- 审查修改记录表 -->
<template>
  <div class="review-modification-recordtable">
    <BaseTable
      :loading="loading"
      :config="config"
      :data="data"
    ></BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable'
export default {
  name: 'ReviewModificationRecordTable',
  components: {
    BaseTable
  },
  props: {
    bdId: {
      type: String,
      default: '' 
    } 
  },
  data() {
    return {
      loading: false,
      config: {
        border: true,
        columns: [
          {
            type: 'index',
            title: '序号',
            width: 60,
          },
          {
            title: '操作人',
            key: 'operator',
            width: 180,
          },
          {
            title: '操作时间',
            key: 'operationTime',
            width: 160,
          },
          {
            title: '投标单位',
            key: 'enterpriseName',
            width: 180,
          },
          {
            title: '操作内容',
            key: 'content',
          },
        ],
        hidePagination: true,
      },
      data: [],
    }
  },
  methods: {
    // 获取修改记录
    async getModificationRecord() {
      try {
        const params = {
          bdId: this.bdId,
        }
        this.loading = true;
        const res = await this.$api.getModificationRecord(params);
        this.loading = false;
        this.data = res.data.data.map((item) => {
          return {
            operator: item.operator,
            operationTime: item.operationTime,
            enterpriseName: item.enterpriseName,
            content: this.createContent(item),
          }
        });
      } catch (error) {
        this.loading = false;
        this.$message.error("获取修改记录失败");
      }
    },
    // 创建操作内容
    createContent(row) {
      const contents = [
        row.depositPaymentStatusDesc ?  `缴纳状态修改为：${row.depositPaymentStatusDesc}` : '',
        row.depositPaymentMethodDesc ?  `缴纳方式修改为：${row.depositPaymentMethodDesc}` : '',
        row.depositReviewResultDesc ?  `审查结果修改为：${row.depositReviewResultDesc}` : '',
        row.remarks?  `添加备注：${row.remarks}` : '',
      ];
      return contents.join('；');
    }
  },
  mounted() {
    this.getModificationRecord();
  },
}
</script>